// extracted by mini-css-extract-plugin
export default {"block":"Video_block__ez4Sh","loader":"Video_loader__NFbab"};